/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Queuename1Inputs */

const en_entity_queuename1 = /** @type {(inputs: Entity_Queuename1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queue Name`)
};

const de_entity_queuename1 = /** @type {(inputs: Entity_Queuename1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Queue Name" |
*
* @param {Entity_Queuename1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_queuename1 = /** @type {((inputs?: Entity_Queuename1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Queuename1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_queuename1(inputs)
	return de_entity_queuename1(inputs)
});
export { entity_queuename1 as "entity_queueName" }